import React, { Component } from "react";
import { Row, Col, Card, CardBody, Button, Label, Alert, Table, CardHeader } from "reactstrap";
import Page from "components/Page";
import {  Textbox } from "react-inputs-validation";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FetchDataCarritoHogar,LimpiarCarritoHogar,setProductoActualCotizadoHogar} from "../../redux/actions/ACarritoProductos";
import { fetchConsultarIdentificacionAP } from "../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { urlConsultarCedula, urlCOnsultaGuardarPersonas, urlFVinculacion } from '../../constants/urls'
import { FetchPost } from '../../redux/actions/api'
import { httpClient } from '../../api/httpClient'


class CotizacionIdentificacionesPaso6 extends Component
 {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(this.props.location.search);    
    this.state = {
      validate: false,
      identificacionSelected:"",
      nombreSelected:"",
      datosItem:[],          
      identificacionHasError:false,
      nombreHasError:false  ,
      loading:false,
      msgValidarPersona:false,
      finalizarIngresoIdentificaciones:true ,
      itemActualizarReact:undefined,  
      idCarrito:queryParams.get('id'),
      numPersonasIngresar:0,
      habilitarGuardarInformacion:true,
      EdadMaximaAdmitida:undefined,
      fechaNacimientoSelected:'',
      fechaHasError:false  ,
      verMsgEdad:false
    };    
  }

  componentDidMount() {
    this.onCargarProductosIngresar();
  }

  async onCargarProductosIngresar()
  {
    let {loading, itemActualizarReact, finalizarIngresoIdentificaciones,idCarrito} = this.state
    this.setState({loading: true});  
    let resp = await FetchPost({
      url: urlCOnsultaGuardarPersonas, param: {
        empresa:"AIGMETROPOLITANA",
        idCarrito : idCarrito,        
      }
    })
    const { transaccion, finalizoActualizacionitems, itemActualizar, EdadMaxima } = resp
    if (transaccion) {
      //Codigo cuando la transaccion es correcta     
      this.setState({finalizarIngresoIdentificaciones: finalizoActualizacionitems, itemActualizarReact:itemActualizar, numPersonasIngresar:itemActualizar.numeroPersonasAccidentesPersonales?itemActualizar.numeroPersonasAccidentesPersonales:0, EdadMaximaAdmitida: parseInt(EdadMaxima)});  
    }
    this.setState({loading: false}); 
  }


toggleValidating(validate) {
  this.setState({ validate });
}

onValidateform = async () => {  
  const { datosItem,finalizarIngresoIdentificaciones,itemActualizarReact, idCarrito} = this.state   
    if(datosItem.length >0)
    {      
          let {loading} = this.state
          this.setState({loading: true});  
          let resp = await FetchPost({
            url: urlCOnsultaGuardarPersonas, param: {
              empresa:"AIGMETROPOLITANA",
              idCarrito : idCarrito,
              datosActualizar:{
                index:itemActualizarReact.nroItem,
                codigoUbicacion:itemActualizarReact.codigo,
                datosPersonas:datosItem
              }
            }
          })
          const { transaccion } = resp
          if (transaccion) {
            //Validar si existen items que se deban ingresar
            if(finalizarIngresoIdentificaciones && finalizarIngresoIdentificaciones === true) 
            {
              //Agregar codigo para Formulario de vnculacion

              let resp = await FetchPost({
                url: urlFVinculacion+idCarrito,
                param:''
              });
              const { transaccion, pasarPantallaFormulario, urlFormulario } = resp;
              if (transaccion) {

                if(pasarPantallaFormulario)
                {
                  this.props.history.push({
                    pathname: "/formulario-vinculacion",
                    search: `?url=${urlFormulario}`,
                    });
                }
                else{
                  this.props.history.push({
                    pathname: '/final-cotizacionbroker' ,
                    search:`?ramo=HOG`
                  });
                }
              }              
            }
            else{
              //inicializar los estados del formulario 
              this.setState({
                validate: false,
                identificacionSelected:"",
                nombreSelected:"",
                datosItem:[],                   
                identificacionHasError:false,
                nombreHasError:false  ,
                loading:false,
                msgValidarPersona:false,
                finalizarIngresoIdentificaciones:true ,
                itemActualizarReact:undefined,
                numPersonasIngresar:0,
                habilitarGuardarInformacion:true  
              });  
              this.onCargarProductosIngresar();
            }
          }
          this.setState({loading: false}); 
    }
    else{
      this.setState({msgValidarPersona:true});
    }  
    
}

onObtenerEdadPersona(fecha){  
  const answer_array = fecha.split('/');  
  let fechaCalculoEdad=`${answer_array[2]}-${answer_array[1]}-${answer_array[0]}`
  //Calcular edad de la persona ingresada                  
  let hoy = new Date();
  let cumpleanos = new Date(fechaCalculoEdad);
  let edad = hoy.getFullYear() - cumpleanos.getFullYear();
  let m = hoy.getMonth() - cumpleanos.getMonth();
  if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
      edad--;
  }
  return edad
}

onAgregarPersonas = async () => {  
  this.toggleValidating(true)
  let {datosItem,identificacionSelected,nombreSelected,fechaNacimientoSelected, validate, nombreHasError, fechaHasError,msgValidarPersona, numPersonasIngresar, habilitarGuardarInformacion, EdadMaximaAdmitida} = this.state 
  //Validar si la infromacion ingresada en el formulario es correcta    
  let valoractualPersonas=numPersonasIngresar
  if(nombreHasError === false && fechaHasError === false && fechaNacimientoSelected !== ''&& nombreSelected !=='' && valoractualPersonas>0 )
  {
      // Validar que la identificacion no este ingresada anteriormente
        let itemsActuales = datosItem.filter((item) =>
        item.nombre === nombreSelected  && item.fechaNacimiento === fechaNacimientoSelected )        
        itemsActuales = itemsActuales[0];   
        if (itemsActuales === undefined || itemsActuales === null )
        {
        //Validar Edad Persona con Parametro
        let getedad=this.onObtenerEdadPersona(fechaNacimientoSelected)
        if(parseInt(getedad) <= EdadMaximaAdmitida)
        {
          let datosAnteriores=datosItem;    

          let registroNuevo={
          identificacion:identificacionSelected,
          nombre:nombreSelected,
          fechaNacimiento:fechaNacimientoSelected
          }
          datosAnteriores.push(registroNuevo)
  
          this.setState({ 
          datosItem: datosAnteriores,
          identificacionSelected:"",
          nombreSelected:"",    
          fechaNacimientoSelected:'',
          msgValidarPersona:false,
          numPersonasIngresar:valoractualPersonas-1,      
          validate:false ,
          verMsgEdad:false 
          });
          if((valoractualPersonas-1)===0 || (valoractualPersonas-1)==='0'){
           this.setState({habilitarGuardarInformacion:false})
          }

        }
        else{
          this.setState({
            verMsgEdad:true
          })
        }
        
        }
  }  
  
  
}


onEliminarElemento = (id) => {
  let {datosItem, numPersonasIngresar} = this.state 
  let itemsActuales = datosItem.filter((item) =>
        item.fechaNacimiento !== id )    
  this.setState({ 
    datosItem: itemsActuales,
    msgValidarPersona:false,
    numPersonasIngresar:numPersonasIngresar+1,
    verMsgEdad:false
  });
}


onConsultarCedula = async (identificacion) =>{

  let {loading} = this.state
  this.setState({loading: true});  
      let resp = await httpClient.get(urlConsultarCedula + identificacion);
      const { transaccion, nombre, fecha_nacimiento } = resp
      if (transaccion) {
        this.setState({nombreSelected: nombre, fechaNacimientoSelected:fecha_nacimiento});                
      }
      this.setState({loading: false});  

      this.toggleValidating(true)
}

  render() {
    let { datosItem,identificacionSelected,nombreSelected, validate, nombreHasError, identificacionHasError, loading, msgValidarPersona, itemActualizarReact,idCarrito, numPersonasIngresar, habilitarGuardarInformacion,fechaNacimientoSelected, fechaHasError, EdadMaximaAdmitida,verMsgEdad} = this.state;           
     let nroitem=(itemActualizarReact && itemActualizarReact.nroItem)?parseInt(itemActualizarReact.nroItem):0;
     nroitem=nroitem+1;           
  return (
          <LoadingScreen
            loading={loading }
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Buscando Información de Persona..."
          >
            <Page title={this.state.codigoProductoEspecial ? "Cotización de Hogar Advance": "Cotización de Hogar Protección Total"} breadcrumbs={[{ name: "Información de Personas", active: true }]}>     

            <div className="container-step">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div className="step current"> {`6. Información Adicional`} </div>
                <div class="step"> {` 7. Emisión `} </div>
                
              </div>
            </div>
            </div> 
            <Row>
                <Col md={12} className="mb-3">
                  <Card className="flex-row ">
                    <CardBody>
                    <CardHeader>Información del Personas para Accidentes Personales</CardHeader>
                    <br></br>
                    <Row>
                        <Col lg={2} ></Col>
                        <Col lg={8} md={12} sm={12} xs={12}>
                          <Alert color="info" isOpen={this.state.visibleAlert} toggle={this.onDismiss}>
                              <center><p>Por favor ingresar la información de identificación (opcional), nombres y fecha de nacimiento de las personas que habitan en la Ubicacion Asegurada. Por favor verifique que la información ingresada sea correcta antes de presionar el botón "GUARDAR INFORMACIÓN".</p></center>
                          </Alert>
                        </Col>
                        <Col lg={2} ></Col>
                    </Row>  
                    <Row>
                        <Col lg={2} ></Col>
                        <Col lg={8} md={12} sm={12} xs={12}>
                          <Row>
                                  <Col lg={3} md={6} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Ubicación #{nroitem}</Label></h5></Col>
                                <Col lg={5} md={6} sm={12} xs={12}>{(itemActualizarReact && itemActualizarReact.direccion)?itemActualizarReact.direccion:""}</Col>                           
                          </Row>
                        </Col>
                        <Col lg={2} ></Col>
                    </Row>    
                      <Row>
                        <Col lg={2} ></Col>
                        <Col lg={8} md={12} sm={12} xs={12}>
                          <Row>
                            <Col lg={3} md={6} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Identificación</Label></h5></Col>
                            <Col lg={5} md={6} sm={12} xs={12}>
                                <Textbox
                                      tabIndex="1"
                                      type="input"
                                      value={identificacionSelected}
                                      name="identificacion"
                                      id="identificacion"
                                      placeholder="Ingrese la cédula de la persona Ejemplo (0105613045)."
                                      classNameInput={"form-control"}
                                      onChange={(identificacion, e) => {
                                        this.setState({ identificacionSelected: identificacion });                                          
                                        if(identificacion.length === 10 ) {
                                          this.onConsultarCedula(identificacion);
                                        }                                                                     
                                      }}
                                      //validate={validate}
                                      validationCallback={res => this.setState({ validate: res,  identificacionHasError: res})} // Optional.[Func].Default: none. Return the validation result.
                                      onBlur={e => this.setState({ blur: true })}
                                      // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                      validationOption={{
                                        name: "Identificación", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                        //check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        //required:true,                                    
                                        reg: /^[0-9]+(\.[0-9]+)?$/, //Optional.[Bool].Default: "" Custom regex.
                                        //type: 'number',
                                        msgOnError: "El número de cédula ingresado es incorrecto." // Optional.[Bool].Default: true. To determin if it is a required field.
                                      }}

                                    />                               
                            </Col>                           
                          </Row>
                        </Col>
                        <Col lg={2} ></Col>
                    </Row>
                    <Row>
                        <Col lg={2} ></Col>
                        <Col lg={8} md={12} sm={12} xs={12}>
                          <Row>                           
                            <Col lg={3} md={6} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Nombre (*)</Label></h5></Col>
                            <Col lg={5} md={6} sm={12} xs={12}>
                                  <Textbox
                                        tabIndex="1"
                                        type="input"
                                        value={nombreSelected}
                                        name="nombre"
                                        id="nombre"
                                        placeholder="Ingrese apellidos y nombres de la persona"
                                        classNameInput={"form-control"}
                                        onChange={(nombre, e) => {
                                          this.setState({ nombreSelected: nombre.toUpperCase() });
                                        }}
                                        validate={validate}
                                        validationCallback={res => this.setState({ validate: res, nombreHasError: res })} // Optional.[Func].Default: none. Return the validation result.
                                        onBlur={e => this.setState({ blur: true })}
                                        // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                        validationOption={{
                                          name: "Nombres", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.                                
                                          required:true,
                                          //reg: /^[0-9]+(\.[0-9]+)?$/, //Optional.[Bool].Default: "" Custom regex.                                    
                                          msgOnError: "Debe ingresar apellidos y nombres de la persona" // Optional.[Bool].Default: true. To determin if it is a required field.
                                        }}

                                      />
                                      
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={2} ></Col>
                    </Row>
                    <Row>
                        <Col lg={2} ></Col>
                        <Col lg={8} md={12} sm={12} xs={12}>
                          <Row>                           
                            <Col lg={3} md={6} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Fecha de Nacimiento(*) (día/mes/año) </Label></h5></Col>
                            <Col lg={5} md={6} sm={12} xs={12}>
                                  <Textbox
                                        tabIndex="1"
                                        type="input"
                                        value={fechaNacimientoSelected}
                                        name="fechanacimiento"
                                        id="fechanacimiento"
                                        placeholder="Ingrese una Fecha Ej. 25/11/1985"
                                        classNameInput={"form-control"}
                                        onChange={(fecha, e) => {
                                          this.setState({ fechaNacimientoSelected: fecha });
                                        }}
                                        validate={validate}
                                        validationCallback={res => this.setState({ validate: res, fechaHasError: res })} // Optional.[Func].Default: none. Return the validation result.
                                        onBlur={e => this.setState({ blur: true })}
                                        // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                        validationOption={{
                                          name: "fechanacimiento", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.                                
                                          required:true,
                                          reg: /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/, //Optional.[Bool].Default: "" Custom regex.                                    
                                          msgOnError: "Debe ingresar una fecha de nacimiento válida en formato día/mes/año Ej.25/09/1985" // Optional.[Bool].Default: true. To determin if it is a required field.
                                        }}

                                      />
                                      
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={2} ></Col>
                    </Row>
                    <Row>
                        <Col lg={2} ></Col>
                        <Col lg={8} md={12} sm={12} xs={12}>
                          <Row>
                                  <Col lg={3} md={6} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Nro. Personas a Ingresar</Label></h5></Col>
                                <Col lg={5} md={6} sm={12} xs={12}>{numPersonasIngresar}</Col>                           
                          </Row>
                        </Col>
                        <Col lg={2} ></Col>
                    </Row> 

                    <Row>
                        <Col lg={2} ></Col>
                        <Col lg={8} md={12} sm={12} xs={12}>
                          <Row>                           
                            <Col lg={2} md={6} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" ></Label></h5></Col>
                            <Col lg={6} md={6} sm={12} xs={12}>
                              <Button onClick={this.onAgregarPersonas} className="btn btn-purple btn btn-secondary" >
                                <i className="fa fa-plus-circle" aria-hidden="true" />{` AGREGAR PERSONA`}
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={2} ></Col>
                    </Row>
                    {verMsgEdad && verMsgEdad===true && 
                      <Row>
                        <Col lg={2} ></Col>
                        <Col lg={8} md={12} sm={12} xs={12}>
                          <Alert color="warning" isOpen={this.state.visibleAlert} toggle={this.onDismiss}>
                            <center><p>{`La persona ingresada no debe ser mayor a ${EdadMaximaAdmitida} años. Por favor `}</p></center>
                          </Alert>
                        </Col>
                        <Col lg={2} ></Col>
                    </Row> 
                    }

                    {msgValidarPersona && msgValidarPersona === true && 
                      <Row>
                          <Col lg={2} ></Col>
                          <Col lg={8} md={12} sm={12} xs={12}>
                            <Alert color="warning" isOpen={this.state.visibleAlert} toggle={this.onDismiss}>
                                <center><p>Para continuar debe ingresar la información de al menos de una persona.</p></center>
                            </Alert>
                          </Col>
                          <Col lg={2} ></Col>
                      </Row>
                    }


                    <Row>
                        <Col lg={2} ></Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <br></br>
                            <Table>
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Identificación</th>
                                    <th>Nombre</th>
                                    <th>Fecha Nacimiento</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                 {datosItem && datosItem.length>0 && datosItem.map((prod,i) => {
                                     return(
                                      <tr key={i}>
                                        <th scope="row">{i+1}</th>
                                        <td>{prod.identificacion}</td>
                                        <td>{prod.nombre}</td>
                                        <td>{prod.fechaNacimiento}</td>
                                        <td>
                                            <Button
                                              className={"button-white"}                                              
                                              onClick={()=> this.onEliminarElemento(prod.fechaNacimiento)}
                                              >  
                                              <i className="fa fa-trash-alt" aria-hidden="true" />{" "}
                                              ELIMINAR
                                            </Button>
                                        </td>
                                      </tr>
                                     )
                                  })                                   
                                 }                                  
                                </tbody>
                              </Table>
                        </Col>
                        <Col lg={2} ></Col>
                    </Row>
                    



                    <Row>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <div style={{textAlign:"center"}}>
                          <Button 
                          disabled={habilitarGuardarInformacion}
                          onClick={this.onValidateform} className="btn btn-primary"                           
                          >
                            <i className="fa fa-save" aria-hidden="true" />{` GUARDAR INFORMACIÓN`}
                          </Button>
                        </div>
                      </Col>
                    </Row>  
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Page>
          </LoadingScreen>
    
  );
  }  
};

const mapStateToProps = state => ({
  catalogo: state.catalogosHogar,
  datosAsesor: state.datosUsuarios.dataUsuario,
  carrito: state.datosCarritoHogar,
  datosIdentificacion : state.datosIdentificacionAP,  
});

const mapDispatchToProps = dispatch => {
  return {
    setCarrito: (datosCarrito) => dispatch(FetchDataCarritoHogar(datosCarrito)),
    limpiarCarrito:()=> dispatch(LimpiarCarritoHogar()),
    setProductoActual:(param)=>dispatch(setProductoActualCotizadoHogar(param)),
    consultarIdentificacion: datos => dispatch(fetchConsultarIdentificacionAP(datos)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionIdentificacionesPaso6)
);

